/* eslint-disable import/order */
import { Grid, Slide } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/global'
import { edit, update } from '../ServiceTypeActions'
import Form from './Form'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

function EditType(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(edit(props.match.params.id))
  }, [])

  const service = useSelector(state => state.serviceType.editingServiceType)

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      if (data && data.code === 200) {
        onClose()
      }
    })
  }

  const onClose = () => {
    history.goBack()
  }

  return (
    <BaseFilterModal
      open
      handleOpen={onClose}
      title="Editar tipo de serviço"
      hiddenHelpButton
    >
      <Grid item container xs={12} style={{ width: '600px' }}>
        <Grid item container xs={12} style={{ marginTop: '.5em' }}>
          <Form
            classes={classes}
            data={service}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(EditType)
